import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { queryFnPOST } from "api/tanStackQuery/helpers";
import { FC } from "react";

import { TrainIdentifierWithIncidentId } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/utils";
import { AffectedTrain } from "features/CenterContent/RoleContent/Vaktleder/types";
import TrainInfoBatchModal, {
  RequestBodyCreateBatch,
} from "features/CenterContent/VehicleDetails/shared/TrainInfoBatchModal";

type OpenTrainBatchResponse = {
  error?: string;
  train_identifiers?: TrainIdentifierWithIncidentId[];
};

type CreateTrainInfoProps = {
  selectedTrains: AffectedTrain[];
  setModalOpen: (v: boolean) => void;
  updateSelectedTrains: (selectedTrain: AffectedTrain) => void;
  addPendingTrains: (trains: TrainIdentifierWithIncidentId[]) => void;
};

export const CreateTrainInfoBatchModal: FC<CreateTrainInfoProps> = ({
  selectedTrains,
  setModalOpen,
  updateSelectedTrains,
  addPendingTrains,
}) => {
  const queryClient = useQueryClient();
  const {
    mutate: postTrainInfo,
    status: postTrainInfoStatus,
    reset: resetMutation,
  } = useMutation({
    mutationFn: ({ body }: RequestBodyCreateBatch) =>
      queryFnPOST<OpenTrainBatchResponse>({
        url: `${getBackendUrl()}/trainInformation/trains`,
        body,
        signal: undefined,
      }),
    onSuccess: (response) => {
      void queryClient.invalidateQueries({
        queryKey: ["routeChangedEvents", ...selectedTrains],
      });
      if (response?.train_identifiers) {
        addPendingTrains(response.train_identifiers);
      }
    },
  });

  return (
    <TrainInfoBatchModal
      selectedTrains={selectedTrains}
      onSubmit={postTrainInfo}
      submitStatus={postTrainInfoStatus}
      updateSelectedTrains={updateSelectedTrains}
      onClose={() => {
        resetMutation();
        setModalOpen(false);
      }}
    />
  );
};
